import { render, staticRenderFns } from "./determine.vue?vue&type=template&id=587d270c&scoped=true&"
import script from "./determine.vue?vue&type=script&lang=js&"
export * from "./determine.vue?vue&type=script&lang=js&"
import style0 from "./determine.vue?vue&type=style&index=0&id=587d270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d270c",
  null
  
)

export default component.exports